export default {
  mode: 'history',
  routes: [
    // 动态路径参数 以冒号开头
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/login/index.vue')
    },
    {
      path: '/registry',
      name: 'registry',
      component: () => import('@/pages/registry/index.vue')
    },
    {
      name: 'index',
      path: '/',
      component: () => import('@/components/QBLayout/index.vue'),
      children: [
        {
          name: 'index',
          path: '/',
          component: () => import('@/components/Index/index.vue')
        },
        {
          name: 'application',
          path: 'application',
          component: () => import('@/pages/application/index.vue'),
          meta: {
            title: '流量管理/应用管理'
          }
        },
        {
          name: 'advertise',
          path: 'advertise',
          component: () => import('@/pages/advertise/index.vue'),
          meta: {
            title: '流量管理/广告位管理'
          }
        },
        {
          name: 'channel',
          path: 'channel',
          component: () => import('@/pages/channel/index.vue'),
          meta: {
            title: '流量管理/渠道号管理'
          }
        },
        // {
        //   name: 'modulesGround',
        //   path: 'modulesGround',
        //   component: () => import('@/pages/modulesGround/index.vue'),
        //   meta: {
        //     title: '流量管理/模块组管理'
        //   }
        // },
        {
          name: 'programData',
          path: 'programData',
          component: () => import('@/pages/programData/index.vue'),
          meta: {
            title: '数据管理/程序化数据'
          }
        },
        // {
        //   name: 'moduleStatistic',
        //   path: 'moduleStatistic',
        //   component: () => import('@/pages/statistic/index.vue'),
        //   meta: {
        //     title: '数据管理/模块数据'
        //   }
        // },
        {
          name: 'requestStatistics',
          path: 'requestStatistics',
          component: () => import('@/pages/requestStatistics/index.vue'),
          meta: {
            title: '数据管理/请求统计'
          }
        },
        {
          name: 'terminalBlacklist',
          path: 'terminalBlacklist',
          component: () => import('@/pages/terminalBlacklist/index.vue'),
          meta: {
            title: '数据管理/终端黑名单'
          }
        },
        {
          name: 'finance',
          path: 'finance',
          component: () => import('@/pages/finance/index.vue'),
          meta: {
            title: '财务管理/结算信息'
          }
        },
        {
          name: 'account',
          path: 'account',
          component: () => import('@/pages/account/index.vue'),
          meta: {
            title: '账户'
          }
        },
        {
          name: 'join',
          path: 'join',
          component: () => import('@/pages/join/index.vue'),
          meta: {
            title: '接入中心'
          }
        },
        {
          name: 'sha1',
          path: 'sha1',
          component: () => import('@/components/sha1/index.vue'),
          meta: {
            title: '帮助中心/SHA1'
          }
        },
        {
          name: 'PrivacyPolicy',
          path: 'PrivacyPolicy',
          component: () => import('@/components/pdf/index.vue'),
          meta: {
            title: '帮助中心/隐私政策'
          }
        },      {
          name: 'Compliance',
          path: 'Compliance',
          component: () => import('@/components/pdf/index2.vue'),
          meta: {
            title: '帮助中心/合规指引'
          }
        },
        // {
        //     name: 'emptyData',
        //     path: 'emptyData',
        //     component:()=>import('@/components/errorStatus/emptyData.vue')
        // },
        // {
        //     name: 'noData',
        //     path: 'noData',
        //     component:()=>import('@/components/errorStatus/noData.vue')
        // },
        // {
        //     name: 'loadingPage',
        //     path: 'loadingPage',
        //     component:()=>import('@/components/loading/loadingPage.vue')
        // },
        // {
        //     name: 'searchLoading',
        //     path: 'searchLoading',
        //     component:()=>import('@/components/loading/searchLoading.vue')
        // },
        // {
        //     name: 'noNetwork',
        //     path: 'noNetwork',
        //     component:require('@/components/errorStatus/noNetwork.vue').default,
        // },
        // {
        //     name: 'error_403',
        //     path: 'error_403',
        //     component:()=>import('@/components/errorStatus/403.vue')
        // },
        // {
        //     name: 'error_500',
        //     path: 'error_500',
        //     component: () => import('@/components/errorStatus/500.vue')
        // },
        // {
        //     name: 'error_404',
        //     path: '*',
        //     component:()=>import('@/components/errorStatus/404.vue')
        // }
      ]
    }
  ]
};
